import React, { useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/styles';
import { CircularProgress } from '@material-ui/core';
import Charts from 'components/Charts';
import LegendItem from './LegendItem';
import Store from 'store/store';
import { AggregateCostAndChargesTypes } from 'store/modules/Charts/types';
import { adviserChargesIndex } from 'components/Settings/Palette/utils';

const { connect, selectors } = Store;

const useStyles = makeStyles({
  container: {
    margin: '1rem 0'
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    margin: 0
  },
  chartContainer: {
    marginTop: '1.5rem',
    backgroundColor: 'white',
    borderRadius: '25px',
    width: '100%',
    minHeight: '27.5rem',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  legend: {
    marginBottom: '1rem',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  chartWrapper: {
    width: '100%',
    height: '100%',
    padding: '1.5rem'
  }
});

interface Props {
  policyId?: number | null;
  isLoading?: boolean;
  aggreagateCostAndCharges: AggregateCostAndChargesTypes[];
}

const AggregateCostAndCharges = ({
  policyId,
  isLoading = false,
  aggreagateCostAndCharges
}: Props) => {
  const theme = useTheme() as any;
  const classes = useStyles();

  useEffect(() => {
    // eslint-disable-next-line
  }, [policyId]);

  const isDataExist = aggreagateCostAndCharges.length > 0;
  return (
    <div className={classes.container}>
      <h5 className={classes.title}>Aggregated cost and charges</h5>
      <div className={classes.chartContainer}>
        {isLoading ? (
          <CircularProgress />
        ) : !isDataExist ? (
          'No data available'
        ) : (
          <div className={classes.chartWrapper}>
            <div className={classes.legend}>
              <LegendItem
                color={
                  theme.palette.baseColors.charts['adviser-charges'][
                    adviserChargesIndex('annualised_contributions')
                  ]
                }
                text="Annualised contributions"
              />
              <LegendItem
                color={
                  theme.palette.baseColors.charts['adviser-charges'][
                    adviserChargesIndex('annualised_withdrawals')
                  ]
                }
                text="Annualised withdrawals"
              />
              <LegendItem
                color={
                  theme.palette.baseColors.charts['adviser-charges'][
                    adviserChargesIndex('product_charges')
                  ]
                }
                text="Cumulative ongoing investment management and product/platform
                charges"
              />
              <LegendItem
                color={
                  theme.palette.baseColors.charts['adviser-charges'][
                    adviserChargesIndex('advisor_charges')
                  ]
                }
                text="Cumulative ongoing adviser charges"
              />
              <LegendItem
                color={
                  theme.palette.baseColors.charts['adviser-charges'][
                    adviserChargesIndex('net_value')
                  ]
                }
                text="Net value at end of period"
              />
            </div>
            <div
              style={{
                fontSize:
                  Number(
                    aggreagateCostAndCharges[
                      aggreagateCostAndCharges.length - 1
                    ].net_value
                  ) >= 100000
                    ? '12px'
                    : '16px'
              }}
            >
              <Charts.IPS.AggregateCostAndCharges
                data={aggreagateCostAndCharges}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default connect((state: any) => ({
  aggreagateCostAndCharges:
    selectors.caseSelectors.aggregateCostAndCharges(state)
}))(AggregateCostAndCharges);
